import React, { Component } from 'react';
import Topbar from '../../components/common/Topbar';
import Footer from '../../components/common/Footer';
import VendorPayment from '../../components/transaction/Vendor/VendorPayment';

class VendorPaymentPage extends Component {
    render() {
        return (
            <>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">

                        <Topbar />

                        <div className="container-fluid">

                            {/* <PageTitle Title="Manage Search Lead" /> */}
                            {
                                <VendorPayment />
                            }

                        </div>

                    </div>

                    <Footer />

                </div>
            </>
        );
    }
}

export default VendorPaymentPage;